'use client'

import BlueHero from './BlueHero'

interface HeroProps {
  title: string
  subtitle?: string
  imageUrl?: string
  description?: string
  variant?: 'photo' | 'blue'
}

// Photo-collage banner (Blog / Contact / Inspirations style): two framed
// photos over a dark newspaper-map background with the faint "Ch" / "R"
// letters and an orange chat bubble — matching the design mockups.
export default function HeroSection({ title, subtitle, imageUrl, description, variant = 'photo' }: HeroProps) {
  if (variant === 'blue') {
    return <BlueHero title={title} />
  }

  const leftImg = imageUrl || '/ghassan-artistic.jpg'

  return (
    <section className="relative w-full overflow-hidden" style={{ minHeight: '340px', background: '#07090e' }}>
      {/* left framed photo */}
      <div style={{ position: 'absolute', left: '-20px', top: 0, bottom: 0, width: '45%', zIndex: 1 }}>
        <img src={leftImg} alt={title} style={{ width: '100%', height: '100%', objectFit: 'cover', opacity: 0.55 }} />
        <div style={{ position: 'absolute', inset: 0, background: 'linear-gradient(90deg, rgba(7,9,14,0.82) 0%, transparent 60%, rgba(7,9,14,0.45) 100%)' }} />
      </div>

      {/* right framed photo */}
      <div style={{ position: 'absolute', right: 0, top: 0, bottom: 0, width: '45%', zIndex: 1 }}>
        <img src="/ghassan-real.jpg" alt="" style={{ width: '100%', height: '100%', objectFit: 'cover', opacity: 0.5 }} />
        <div style={{ position: 'absolute', inset: 0, background: 'linear-gradient(270deg, rgba(7,9,14,0.82) 0%, transparent 60%, rgba(7,9,14,0.45) 100%)' }} />
      </div>

      {/* newspaper texture */}
      <div
        className="absolute inset-0 pointer-events-none"
        style={{
          backgroundImage:
            'repeating-linear-gradient(0deg, transparent, transparent 18px, rgba(255,255,255,0.03) 18px, rgba(255,255,255,0.03) 19px)',
          zIndex: 1,
          opacity: 0.5,
        }}
      />

      {/* faint Ch / R */}
      <div style={{ position: 'absolute', left: '18px', bottom: '-10px', zIndex: 2, fontSize: '220px', fontWeight: 900, color: 'transparent', WebkitTextStroke: '1.5px rgba(255,255,255,0.10)', lineHeight: 1, pointerEvents: 'none', userSelect: 'none' }}>Ch</div>
      <div style={{ position: 'absolute', right: '24px', top: '20px', zIndex: 2, fontSize: '160px', fontWeight: 900, color: 'transparent', WebkitTextStroke: '1.5px rgba(255,255,255,0.08)', lineHeight: 1, pointerEvents: 'none', userSelect: 'none' }}>R</div>

      {/* title */}
      <div className="relative z-10 flex flex-col items-center justify-center text-center px-4" style={{ minHeight: '340px' }}>
        <h1 style={{ fontSize: 'clamp(28px, 5vw, 44px)', fontWeight: 900, color: '#fff', letterSpacing: '0.12em', textShadow: '0 2px 20px rgba(0,0,0,0.5)' }}>{title}</h1>
        {subtitle && <p style={{ marginTop: '12px', fontSize: '17px', fontWeight: 700, color: '#f97316', letterSpacing: '0.08em', textTransform: 'uppercase' }}>{subtitle}</p>}
        {description && <p style={{ marginTop: '14px', fontSize: '14px', color: 'rgba(255,255,255,0.72)', maxWidth: '620px' }}>{description}</p>}
      </div>

      {/* chat bubble */}
      <div className="absolute flex items-center justify-center rounded-full" style={{ bottom: '20px', right: '20px', width: '48px', height: '48px', background: '#f97316', boxShadow: '0 4px 16px rgba(249,115,22,0.45)', zIndex: 20 }}>
        <svg width="20" height="20" viewBox="0 0 24 24" fill="white"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" /></svg>
      </div>
    </section>
  )
}
